var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 29.999c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5S37.757 29.999 35 29.999zM35 42.001c-5.131 0-9-2.603-9-6.053v-.896c0-1.684 1.369-3.053 3.052-3.053h11.896c1.683 0 3.052 1.369 3.052 3.053v.896C44 39.398 40.131 42.001 35 42.001zM24 16c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5S26.757 16 24 16zM13 29.999c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5S15.757 29.999 13 29.999zM13 42.001c-5.131 0-9-2.603-9-6.053v-.896c0-1.684 1.369-3.053 3.052-3.053h11.896c1.683 0 3.052 1.369 3.052 3.053v.896C22 39.398 18.131 42.001 13 42.001zM31.905 18.73C31.374 18.281 30.697 18 29.948 18H18.052c-.748 0-1.426.281-1.957.73l0 0C18.404 19.875 20 22.251 20 24.999c0 .8-.141 1.565-.39 2.282l0 0c1.284.461 2.774.72 4.39.72s3.106-.259 4.39-.72C28.141 26.564 28 25.799 28 24.999 28 22.251 29.596 19.875 31.905 18.73z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.9749d72474f478985738aca75a563027.svg";
export { ForwardRef as ReactComponent };